export default {
  getCandidateComment: (state) => state.candidateComment,
};
